import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation UnpinPostReply($replyId: ObjectID!) {
    unpinPostReply(replyId: $replyId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
